export const Vue = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="500"
      height="500"
      viewBox="0 0 500 500"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <rect width="500" height="500" fill="white" />
      <g clip-path="url(#clip0_2967_824)">
        <path
          d="M295.712 79.0016L249.987 158.212L204.262 79.0016H51.9922L249.987 421.998L447.982 79.0016H295.712Z"
          fill="black"
        />
        <path
          d="M295.711 79.0011L249.986 158.212L204.262 79.0011H131.189L249.986 284.795L368.784 79.0011H295.711Z"
          fill="#757575"
        />
      </g>
      <defs>
        <clipPath id="clip0_2967_824">
          <rect
            width="396"
            height="343"
            fill="white"
            transform="translate(52 79)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
